"use client";

import Script from "next/script";
import { PADDLE_CONFIG } from "@/lib/billing/paddle";

export function PaddleLoader() {
  if (
    process.env.NEXT_PUBLIC_PAYMENTS_ENABLED !== "true" ||
    !PADDLE_CONFIG.clientToken
  ) {
    return null;
  }

  return (
    <Script
      src="https://cdn.paddle.com/paddle/v2/paddle.js"
      strategy="lazyOnload"
      onLoad={() => {
        const paddle = (window as any).Paddle;
        if (!paddle) return;

        // Environment must be set before Initialize in Paddle.js v2
        if (PADDLE_CONFIG.environment === "sandbox") {
          paddle.Environment.set("sandbox");
        }

        paddle.Initialize({
          token: PADDLE_CONFIG.clientToken,
          eventCallback: (event: { name: string }) => {
            if (event.name === "checkout.completed") {
              (window as any).__paddleCheckoutCompleted = true;
            }
            if (event.name === "checkout.closed" && (window as any).__paddleCheckoutCompleted) {
              (window as any).__paddleCheckoutCompleted = false;
              window.location.href = window.location.pathname + "?upgraded=1";
            }
          },
        });
      }}
    />
  );
}
